import React from 'react';
import Stack, { contentStackSpacing } from '../../v2BaseComponents/Stack';
import Text from '../../v2BaseComponents/Text';
import { useLoadedUser } from '../../../hooks/api/useUser';
import { getIntl } from '../../../utils/intl';
import MaxWidthRestrictedContent from '../../v2BaseComponents/MaxWidthRestrictedContent';
import MainContentContainer from '../../v2BaseComponents/MainContentContainer';
import { ActionButtonLayout } from '../../v2BaseComponents/ActionButtonLayout';

const intl = getIntl('JoinWithNoPendingInvitations', {
    header: 'Join an Organization',
    subHeader:
        'To join an existing organization, you must have an invitation from the organization administrator. If you have not received an invitation, please contact the organization administrator.  Be sure your administrator sends an invite to the same email you used to sign up for primary record.',
    yourEmail: 'Your Primary Record Email:',
});

export type JoinWithNoPendingInvitationsOwnProps = {};

export type JoinWithNoPendingInvitationsProps = JoinWithNoPendingInvitationsOwnProps;

const JoinWithNoPendingInvitations: React.FC<JoinWithNoPendingInvitationsProps> = () => {
    const { user } = useLoadedUser({});
    return (
        <ActionButtonLayout scrollable whiteBackground>
            <MaxWidthRestrictedContent>
                <MainContentContainer>
                    <Stack vertical justify="flex-start" align="center" fullWidth space={contentStackSpacing}>
                        <Text variant="h4">{intl('header')}</Text>
                        <Text variant="body-1">{intl('subHeader')}</Text>
                        <Stack vertical fullWidth align="center">
                            <Text variant="caption-1">{intl('yourEmail')}</Text>
                            <Text variant="bold-body-1">{user.email}</Text>
                        </Stack>
                    </Stack>
                </MainContentContainer>
            </MaxWidthRestrictedContent>
        </ActionButtonLayout>
    );
};

export default React.memo(JoinWithNoPendingInvitations);
